package rendering

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.spring
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

/**
 * Manages board spin-tilt animation state.
 *
 * When a rotation occurs, the board tilts slightly in the direction of the
 * rotation, then springs back to zero.
 *
 * Call [applySpinTilt] with a rotation direction (+1 = CW, -1 = CCW).
 * Read [rotationZ] to get the current rotation to apply via graphicsLayer.
 */
class TiltState {
    /** Animatable rotation in degrees. */
    val rotationZ = Animatable(0f)

    /**
     * Applies a spin tilt in the given direction.
     *
     * @param scope     CoroutineScope to launch the animation in.
     * @param direction +1 for clockwise, -1 for counter-clockwise.
     * @param maxDeg    Maximum tilt angle in degrees (default 3.5°).
     */
    fun applySpinTilt(scope: CoroutineScope, direction: Int, maxDeg: Float = 3.5f) {
        if (direction == 0) return
        scope.launch {
            // Snap to tilt angle
            rotationZ.snapTo(direction * maxDeg)
            // Spring back to zero with a bouncy spring
            rotationZ.animateTo(
                targetValue = 0f,
                animationSpec = spring(dampingRatio = 0.4f, stiffness = 300f),
            )
        }
    }
}
